const HTTP = 'EFFECT_HTTP';
const LOCATION = 'LOCATION';

const location = url => ({
  type: LOCATION,
  payload: url,
});

const track = (event, action) => ({
  type: action.type,
  payload: action.payload,
  meta: {
    analytics: {
      channel: event,
    },
  },
});

const http = ({ call, data = {} }) => ({
  type: HTTP,
  payload: {
    call,
    data,
  },
});

exports.track = track;
exports.http = http;
exports.location = location;



// WEBPACK FOOTER //
// ../shared/optilit-action-creators/src/index.js